import { render } from "./WhiteBlock.vue?vue&type=template&id=15dbc15c&scoped=true"
import script from "./WhiteBlock.vue?vue&type=script&lang=js"
export * from "./WhiteBlock.vue?vue&type=script&lang=js"

import "./WhiteBlock.vue?vue&type=style&index=0&id=15dbc15c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15dbc15c"]])

export default __exports__